import { combineReducers } from "@reduxjs/toolkit";

import weedfetti from "../slices/weedfetti";
import cart from "./cart";
import cartDispensary from "./cartDispensary";
import complianceRuleset from "./complianceRules";
import config from "./config";
import dispensary from "./dispensary";
import header from "./header";
import hydration, { HYDRATE, HydrateAction } from "./hydration";
import location from "./location";
import order from "./order";
import search from "./search";
import toasts from "./toasts";
import user from "./user";

const combinedReducer = combineReducers({
  cart,
  cartDispensary,
  complianceRuleset,
  config,
  dispensary,
  header,
  hydration,
  location,
  order,
  search,
  toasts,
  user,
  weedfetti,
});

const rootReducer: typeof combinedReducer = (state, action) => {
  /**
   * This will apply all state from the initial SSR hydration to the client's state.
   * This should only happen once when the frontend parses the initial state from SSR.
   * Subsequent calls to HYDRATE, like when you do a client-side page navigation, should
   * fall through to: combinedReducer(state, action) allowing you to handle the
   * hydration in a reducer.
   *
   * Note that if you dispatch any redux events in `getServerSideProps` or `getStaticProps`,
   * you MUST handle the hydration action in the corresponding reducers if you want data
   * from those events will not be persisted to the redux store during client-side navigation.
   */
  if (action.type === HYDRATE && !state?.hydration?.hasHydrated) {
    return combinedReducer(
      { ...state, ...(action as HydrateAction).payload },
      action,
    );
  } else {
    return combinedReducer(state, action);
  }
};

export default rootReducer;
